import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the context
const GlobalContext = createContext();

// Provider component that wraps your application
export const GlobalProvider = ({ children }) => {
    const [casdoorConfig, setCasdoorConfig] = useState(null);
    const [user, setUser] = useState(null);
    const [authToken, setAuthToken] = useState(null);
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

    // Cross-tab org-switch guard. The auth token lives in a cookie shared by
    // every tab: after a switch in ONE tab, other tabs would silently issue
    // new-org API calls under old-org UI. The chooser stamps
    // 'org_switched_at' into localStorage right after its wipe; the storage
    // event only fires in OTHER tabs, which reload into the new org.
    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === 'org_switched_at' && e.newValue) {
                // Dashboard surfaces only. GlobalProvider also wraps PUBLIC
                // Pages-Router pages (e.g. the org intake form) — a visitor
                // mid-form must never be hard-reloaded because a dashboard
                // tab in the same browser switched orgs.
                if (window.location.pathname.indexOf('/dashboard') === 0) {
                    window.location.reload();
                }
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarExpanded(!isSidebarExpanded);
    };
    
    // Provide all state variables and setters through context
    const value = {
        casdoorConfig,
        setCasdoorConfig,
        user,
        setUser,
        authToken,
        setAuthToken,
        isSidebarExpanded,
        setIsSidebarExpanded,
        toggleSidebar
    };

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
};

// Custom hook to use the global context
export const useGlobalContext = () => useContext(GlobalContext);
